import { R1FactType } from '@/api/rest/resources/types/fact';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';

type GeojsonFactObject = {
  asset_id: string;
  uri: string;
  provenance: {
    description: string;
    source_dataset: string;
  };
};
type GeojsonFact = {
  grid: GeojsonFactObject;
  zonal_stats: GeojsonFactObject;
};

export const usePlotCells = () => {
  const plotFacts = usePlotFacts<GeojsonFact>([R1FactType.habitat_intactness_geojson_urls]);
  const geojsonUrl = getFactFromFactArray<GeojsonFact>(plotFacts, R1FactType.habitat_intactness_geojson_urls)?.value;

  return geojsonUrl?.zonal_stats?.uri ?? '';
};
